import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  FiservCardInterface,
  Preloader,
  ResetIcon,
  useResponsive,
} from '@common-fe/common-fe';

import DisableActionHintWrapper from '@/modules/transaction/components/Cards/components/DisableActionHintWrapper.tsx';

import { CardStatusActionWrap } from '../ChangeStatusCardModal.styles';

import CardActionCardHeader from './CardActionCardHeader';

interface CardReplaceActionCardProps {
  loadingButton?: boolean;
  isMailWithin7Days: boolean;
  card: FiservCardInterface;
  onOpenCardReplacementModal: () => void;
}

const CardReplaceActionCard: React.FC<CardReplaceActionCardProps> = ({
  loadingButton,
  isMailWithin7Days,
  card,
  onOpenCardReplacementModal,
}) => {
  const { isMobile } = useResponsive();
  const { t } = useTranslation();

  return (
    <CardStatusActionWrap
      background="canvas"
      $isMobile={isMobile}
      round="container1Round"
      border={{ color: 'border2', size: 'small' }}
    >
      <CardActionCardHeader
        icon={<ResetIcon size="xlarge" color="iconAccent" />}
        title={t('Replace')}
        description={isMobile ? (
          t('Get a new card if there are any issues.')
        ) : (
          <>
            {t('Get a new card if there are')}
            <br />
            {t('any issues.')}
          </>
        )}
        descriptionLineHeight="20px"
      />
      <DisableActionHintWrapper
        card={card}
        hideHint={!isMailWithin7Days}
        hintElement={
          <AppButton
            width="100%"
            buttonType="primary"
            disabled={isMailWithin7Days || loadingButton}
            onClick={onOpenCardReplacementModal}
          >
            {loadingButton ? (
              <Box width="100%" align="center">
                <Preloader color="white" />
              </Box>
            ) : (
              t('Replace Card')
            )}
          </AppButton>
        }
      />
    </CardStatusActionWrap>
  );
};

export default CardReplaceActionCard;
